// Mock data for teaser demo components with realistic trading data
export const mockSwapData = {
  strategies: [
    { 
      name: 'Elite Scalper', 
      performance: '+$2,450', 
      action: 'promote', 
      color: 'green',
      fromAccount: 'Account2',
      toAccount: 'Account1',
      winRate: 74.2,
      profitFactor: 1.85
    },
    { 
      name: 'Beta Trader', 
      performance: '-$890', 
      action: 'demote', 
      color: 'red',
      fromAccount: 'Account1', 
      toAccount: 'Account2',
      winRate: 45.8,
      profitFactor: 0.73
    },
    {
      name: 'Momentum Pro',
      performance: '+$1,340',
      action: 'promote',
      color: 'green',
      fromAccount: 'Account3',
      toAccount: 'Account1',
      winRate: 68.9,
      profitFactor: 1.42
    }
  ],
  symbol: 'BTCUSDT',
  accounts: ['Account1 (Elite)', 'Account2 (Standard)', 'Account3 (Basic)']
};

export const mockOptimizationData = {
  allocations: [
    { strategy: 'Momentum Pro', allocation: 35.2, account: 'Account1', performance: '+$4,230' },
    { strategy: 'Mean Revert', allocation: 28.7, account: 'Account2', performance: '+$1,890' },
    { strategy: 'Breakout V2', allocation: 22.1, account: 'Account1', performance: '+$2,450' },
    { strategy: 'Grid Master', allocation: 14.0, account: 'Account3', performance: '+$780' }
  ],
  metrics: {
    expectedReturn: 15.8,
    expectedRisk: 12.3,
    sharpeRatio: 1.28,
    totalCapital: '$45,000'
  }
};

export const mockStrategyHealthData = {
  strategy: 'Elite Scalper',
  healthScore: 87,
  components: {
    performance: { score: 92, max: 40, color: 'green', label: 'Performance' },
    stability: { score: 78, max: 25, color: 'yellow', label: 'Stability' },
    lifecycle: { score: 95, max: 20, color: 'green', label: 'Lifecycle' },
    regimeFit: { score: 82, max: 15, color: 'green', label: 'Regime Fit' }
  },
  metrics: {
    winRate: 74.2,
    profitFactor: 1.85,
    sharpeRatio: 2.34,
    maxDrawdown: -8.7,
    totalTrades: 1247
  }
};

export const mockTradeData = [
  {
    id: 1,
    timestamp: '2024-01-15 14:32:15',
    symbol: 'BTCUSDT',
    side: 'BUY',
    quantity: 0.25,
    price: 42350.50,
    pnl: '+$127.45',
    pnlColor: 'green',
    status: 'closed'
  },
  {
    id: 2,
    timestamp: '2024-01-15 15:18:42',
    symbol: 'ETHUSDT',
    side: 'SELL',
    quantity: 1.8,
    price: 2580.30,
    pnl: '-$43.20',
    pnlColor: 'red',
    status: 'closed'
  },
  {
    id: 3,
    timestamp: '2024-01-15 16:05:33',
    symbol: 'BTCUSDT',
    side: 'BUY',
    quantity: 0.15,
    price: 42890.25,
    pnl: '+$89.15',
    pnlColor: 'green',
    status: 'closed'
  },
  {
    id: 4,
    timestamp: '2024-01-15 16:47:18',
    symbol: 'SOLUSDT',
    side: 'SELL',
    quantity: 25.0,
    price: 98.45,
    pnl: '+$234.80',
    pnlColor: 'green',
    status: 'open'
  }
];

export const mockPerformanceEvolutionData = {
  strategy: 'Momentum Pro',
  timeSeriesData: [
    { date: '2024-01-01', score: 78, pnl: 1250 },
    { date: '2024-01-08', score: 82, pnl: 2100 },
    { date: '2024-01-15', score: 85, pnl: 3450 },
    { date: '2024-01-22', score: 88, pnl: 4890 },
    { date: '2024-01-29', score: 91, pnl: 6320 }
  ],
  trend: 'improving',
  currentScore: 91,
  scoreChange: '+13 pts'
};

export const mockMonteCarloData = {
  projections: [
    { path: 1, values: [45000, 46200, 47800, 49100, 52300] },
    { path: 2, values: [45000, 44100, 46500, 48900, 51200] },
    { path: 3, values: [45000, 47300, 45800, 47600, 53100] },
    { path: 4, values: [45000, 43800, 45200, 46800, 48900] },
    { path: 5, values: [45000, 46800, 49200, 51500, 55200] }
  ],
  timeLabels: ['Now', '1M', '3M', '6M', '1Y'],
  confidence: {
    p95: 58200,
    p50: 51200,
    p5: 44800
  },
  currentValue: 45000
};

export const mockRiskScenarioData = {
  scenarios: {
    best: { return: 28.5, volatility: 15.2, probability: 15 },
    likely: { return: 18.7, volatility: 22.8, probability: 60 },
    worst: { return: -12.3, volatility: 35.4, probability: 25 }
  },
  metrics: [
    { label: 'Value at Risk (95%)', value: '$3,240', description: 'Maximum expected loss' },
    { label: 'Expected Return', value: '18.7%', description: 'Most probable annual return' },
    { label: 'Sharpe Ratio', value: '1.42', description: 'Risk-adjusted performance' }
  ]
};

export const mockCapitalDeploymentData = {
  totalCapital: 50000,
  currentAllocations: [
    { strategy: 'Elite Scalper', allocation: 40, amount: 20000 },
    { strategy: 'Momentum Pro', allocation: 35, amount: 17500 },
    { strategy: 'Mean Revert', allocation: 25, amount: 12500 }
  ],
  projectedReturn: 22.4,
  projectedRisk: 18.7,
  compoundingPeriod: '1 Year',
  reinvestmentRate: 100
};

export const mockMarketAdaptiveData = {
  currentRegime: 'Bull Market',
  regimeConfidence: 78,
  adaptations: [
    {
      strategy: 'Momentum Pro',
      currentAllocation: 35.2,
      suggestedAllocation: 42.0,
      reason: 'Optimal for bull market conditions',
      change: '+6.8%'
    },
    {
      strategy: 'Mean Revert',
      currentAllocation: 28.7,
      suggestedAllocation: 22.0,
      reason: 'Reduced effectiveness in trending markets',
      change: '-6.7%'
    },
    {
      strategy: 'Breakout V2',
      currentAllocation: 22.1,
      suggestedAllocation: 25.0,
      reason: 'Enhanced momentum opportunities',
      change: '+2.9%'
    }
  ],
  lifecycleStages: {
    'Momentum Pro': { stage: 'Mature', confidence: 92 },
    'Mean Revert': { stage: 'Declining', confidence: 76 },
    'Breakout V2': { stage: 'Growing', confidence: 84 }
  }
};